import React, { useState, useEffect } from "react";
// import "../dashboard/dashboard.scss";
import "./managedAttribution.scss"
import { Sidebar } from "../../components/sidebar/sidebar";
import { Navbar } from "../../components/navbar/navbar.jsx";
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
import AddIcon from '@mui/icons-material/Add';
import { AddManagedAccount } from '../../modals/addManagedAccountModal.jsx';
import { ManagedAccount } from '../../modals/managedAccountModal.jsx';
import { EditAccountLogins } from '../../modals/editAccountLoginsModal.jsx'
import { useNavigate } from 'react-router-dom';
import { fetchAuthSession, getCurrentUser } from 'aws-amplify/auth';

export const ManagedAttribution = () => {
  //Set the constructs to use in the form
  const [accounts, setAccounts] = useState("");
  const [expandedIds, setExpandedIds] = useState({});
  const [addManagedAccountOpen, setAddManagedAccountOpen] = React.useState(false);
  const [managedAccountOpen, setManagedAccountOpen] = React.useState(false);
  const [editaccountloginsOpen, setEditaccountloginsOpen] = React.useState(false);
  const [editName, setEditName] = useState("");
  const [editDob, setEditDob] = useState("");
  const [editRace, setEditRace] = useState("");
  const [editGender, setEditGender] = useState("");
  const [editLocation, setEditLocation] = useState("");
  const [editPhoto, setEditPhoto] = useState("");
  const [editMainAccount, setEditMainAccount] = useState("");
  const [editIdNum, setEditIdNum] = useState("");
  const [editAccounts, setEditAccounts] = useState("");
  const [userToken, setUserToken] = useState(null);
  const navigate = useNavigate();


  // Handle verification
  const getUserToken = async () => {
    try {
      const session = await fetchAuthSession();
      const access_token = session.tokens.accessToken.toString();
      // console.log('Access Tokens',access_token);
      setUserToken(access_token);
      return access_token
    } catch {
      navigate("/login")
    }
  };

  const toggleExpand = (id) => {
    setExpandedIds(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  useEffect(() => {
    getUserToken();
  }, [])

  //Import the data from the database
  useEffect(() => {
    const fetchManagedAccounts = async () => {
      if (!userToken) return;

      try {
        const response = await fetch('https://api.weathervaneintel.com/api/api/getmanaged_attribution_bio', {
          method: 'POST',
          headers: { "Content-Type": "application/json", "access_token": "example_user_token" },
          body: JSON.stringify([{ userToken }])
        });

        if (response.status === 403) {
          // Redirect unauthorized user to login
          navigate("/login");
          return; // stop further execution
        }

        if (!response.ok) {
          console.warn("API Error:", response.status, response.statusText);
          return;
        }

        const data = await response.json();
        setAccounts(data);

      } catch (err) {
        console.error("Network or fetch error:", err);
      }
    };

    fetchManagedAccounts();
  }, [addManagedAccountOpen, managedAccountOpen, editaccountloginsOpen, userToken]);


  const addManagedAccountFunc = () => {
    // console.log("Add New Group expanded");
    setAddManagedAccountOpen(true);
  };

  const addManagedAccountFuncClose = () => {
    // console.log("Editing a protectee");
    setAddManagedAccountOpen(false);
  };

  const ManagedAccountFunc = (id_num, name, dob, race, gender, location, photo, mainAccount) => {
    // console.log("Add New Group expanded");
    setEditIdNum(id_num);
    setEditName(name);
    setEditDob(dob);
    setEditRace(race);
    setEditGender(gender);
    setEditLocation(location);
    setEditPhoto(photo);
    setEditMainAccount(mainAccount);
    setManagedAccountOpen(true);
  };

  const managedAccountFuncClose = () => {
    // console.log("Editing a protectee");
    setManagedAccountOpen(false);
  };

  const editAccountLoginsFunc = (id_num, name, accounts) => {
    // console.log("Editing the login info");
    setEditIdNum(id_num);
    setEditName(name);
    setEditAccounts(accounts);
    setEditaccountloginsOpen(true);
  };

  const editAccountLoginsFuncClose = () => {
    // console.log("Editing a protectee");
    setEditaccountloginsOpen(false);
  };

  //mainPage
  if (userToken === null) {
    return (
      <div className="loadingdiv">
        <h1>...Loading...</h1>
      </div>
    )
  } else {
    return (
      <div className="managedattributionhomecontainer">
        {/* <Navbar/> */}
        <div className="managedattributionmain">
          <div className="customToolBar">
            <button className="customButton" onClick={addManagedAccountFunc}>Add Account</button>
          </div>
          <div className="bottom ">
            {
              accounts && accounts.map(accountInfo => {
                return (
                  <div className={`biography boxSubComponent ${expandedIds[accountInfo.id_num] ? "expanded" : ""}`}>
                    <div
                      className="biographytitle"
                      onClick={() => toggleExpand(accountInfo.id_num)}
                    >
                      <div className="biotitle">
                        <h3>{accountInfo.name}</h3>
                      </div>

                      <div className="expandIcon">
                        <ExpandCircleDownIcon />
                      </div>
                      <div className="buttons">
                        <button onClick={() => { ManagedAccountFunc(accountInfo.id_num, accountInfo.name, accountInfo.dob, accountInfo.race, accountInfo.gender, accountInfo.location, accountInfo.photo, accountInfo.main_account) }}>Edit Info</button>
                        <button onClick={() => { editAccountLoginsFunc(accountInfo.id_num, accountInfo.name, accountInfo.accounts) }}>Edit Logins</button>
                      </div>
                    </div>
                    {/* <hr /> */}
                    <div className="biographydetails">
                      <table>
                        <tr>
                          <th>Name:</th>
                          <td>{accountInfo.name}</td>
                        </tr>
                        <tr>
                          <th>Date of Birth:</th>
                          <td>{accountInfo.dob}</td>
                        </tr>
                        <tr>
                          <th>Race:</th>
                          <td>{accountInfo.race}</td>
                        </tr>
                        <tr>
                          <th>Gender:</th>
                          <td>{accountInfo.gender}</td>
                        </tr>
                        <tr>
                          <th>Location:</th>
                          <td>{accountInfo.location}</td>
                        </tr>
                        <tr>
                          <th>Photo:</th>
                          <td>{accountInfo.photo}</td>
                        </tr>
                        <tr>
                          <th>Main Account?</th>
                          <td>{accountInfo.main_account}</td>
                        </tr>
                      </table>
                    </div>

                  </div>
                )
              })

            }
          </div>
          <div className="modals">
            <AddManagedAccount isOpen={addManagedAccountOpen} onClose={addManagedAccountFuncClose} />
            <ManagedAccount isOpen={managedAccountOpen} onClose={managedAccountFuncClose} id_num={editIdNum} editName={editName} editDob={editDob} editRace={editRace} editGender={editGender} editLocation={editLocation} editPhoto={editPhoto} editMainAccount={editMainAccount} />
            <EditAccountLogins isOpen={editaccountloginsOpen} onClose={editAccountLoginsFuncClose} id_num={editIdNum} editName={editName} editAccounts={editAccounts} />
          </div>
        </div>
      </div>
    )
  }
}
